import {Normalizer} from "../types";

// 'mernis' normalizer'i — DosyaBorcluMernisCevap (uyap/DosyaBorcluMernis.ts) girdisini
// tek sabit entity'ye (key: 'adres') indirger.
//
// Gercek sekil (parse() veri yapisini DEGISTIRMEZ, sadece message ekler):
//   cevap.sorguSonucDVO.mernisAdres.adresler: Array<Adresler>
//   adresler[0].AdresTipi: string ('IlIlceMerkeziAdresi' | 'Bilinmiyor' | ...)
//   adresler[0].ilIlceMerkeziAdresi: OPSIYONEL — AdresTipi 'Bilinmiyor' iken bu alan
//     objede HIC yok (DosyaBorcluMernis.ts:110 yorumdaki 2. mock).
//
// 'acik adres' diye tek bir kaynak alan YOK; csbm (cadde/sokak/blok) + disKapiNo
// (+ opsiyonel icKapiNo) birlestirilerek turetilir.
export const mernisNormalizer: Normalizer = (cevap) => {
    const bos = {entities: []};

    try {
        if (!cevap || typeof cevap !== "object") {
            return bos;
        }

        const adresler = cevap.sorguSonucDVO?.mernisAdres?.adresler;
        if (!Array.isArray(adresler) || adresler.length === 0) {
            return bos;
        }

        // Tek sabit key 'adres' — yalnizca ilk/aktif adres kaydi kullanilir (parse()'in
        // mesaj uretirken bakdigi kayitla tutarli).
        const ilkAdres = adresler[0];
        if (!ilkAdres || typeof ilkAdres !== "object") {
            return bos;
        }

        const detay = ilkAdres.ilIlceMerkeziAdresi;
        if (!detay || typeof detay !== "object") {
            // AdresTipi 'Bilinmiyor' oldugunda bu alan hic yok — adres bilinmiyor demektir.
            return bos;
        }

        const il: unknown = detay.il;
        const ilce: unknown = detay.ilce;
        const mahalle: unknown = detay.mahalle;

        const acikAdresParcalari = [detay.csbm, detay.disKapiNo, detay.icKapiNo]
            .filter((parca): parca is string => typeof parca === "string" && parca.trim().length > 0)
            .map((parca) => parca.trim());
        const acikAdres = acikAdresParcalari.length > 0 ? acikAdresParcalari.join(" ") : undefined;

        const attrs: Record<string, unknown> = {};
        if (typeof il === "string" && il.length > 0) attrs.il = il;
        if (typeof ilce === "string" && ilce.length > 0) attrs.ilce = ilce;
        if (typeof mahalle === "string" && mahalle.length > 0) attrs.mahalle = mahalle;
        if (acikAdres !== undefined) attrs.acikAdres = acikAdres;

        const etiketParcalari = [mahalle, ilce, il].filter(
            (parca): parca is string => typeof parca === "string" && parca.length > 0
        );
        const label = etiketParcalari.length > 0 ? etiketParcalari.join(", ") : "adres";

        return {
            entities: [
                {
                    key: "adres",
                    label,
                    attrs
                }
            ]
        };
    } catch {
        // ASLA THROW ETME: beklenmeyen sekil gelirse bos entities don.
        return bos;
    }
};
